$(document).ready(function () {
  
  $(".products-slider .product-list").slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1320,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        }
      }
    ]
  });

  $(".spec-slider-main .spec-slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        }
      }
    ]
  });
  
});
  
  // tabbed content
  // http://www.entheosweb.com/tutorials/css/tabs.asp
  $(".tab-container .tab_content").hide();
  // $(".tab-container .tab_content:first").show();
  $('.tab-container').each(function(k,v){
    $(v).find('.tab_content:first').show();
  });
  
  /* if in tab mode */
  $("ul.tabs li").click(function() {
    var parent = $(this).parents('.tab-container');
  
    $(parent).find(".tab_content").hide();
    var activeTab = $(this).attr("rel");
    $(parent).find("#"+activeTab).fadeIn();
  
    $(parent).find("ul.tabs li").removeClass("active");
    $(this).addClass("active");
  
    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
    setTimeout(function(){
      $('.product-list').slick('refresh');  
    },100);
    
  
  });
  /* if in drawer mode */
  $(".tab_drawer_heading").click(function() {
    var parent = $(this).parents('.tab-container');
  
    $(parent).find(".tab_content").hide();
    var d_activeTab = $(this).attr("rel");
    $(parent).find("#"+d_activeTab).fadeIn();
  
    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");
  
    $(parent).find("ul.tabs li").removeClass("active");
    $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");

    setTimeout(function(){
      $('.product-list').slick('refresh');  
    },100);
  });
  
  
  /* Extra class "tab_last"
     to add border to right side
     of last tab */
  $('ul.tabs li').last().addClass("tab_last");


  // mobile Tab
  $(document).on('click','.select-label', function () {
      if($(this).parent().hasClass('active')){
        $(this).parent().removeClass('active');
      }else{
        $('.dropdown').removeClass('active');
        $(this).parent().addClass('active');
      }
  });
  $(document).on('click','.dropdown-list li', function () {
      $(this).parents('.dropdown').find('.select-label_inner').text($(this).text());
      $(this).parents('.dropdown').removeClass('active');
      var variant_id = $(this).data('value');
      $(this).parents('.main_variant_div').parent().find('.product-variant-id').val(variant_id);
  });

  document.addEventListener('DOMContentLoaded', function () {
  // grid list view handler
  const customViewBtns = document.querySelectorAll('.grid_list_view .custom_view_layout');
  const productContainer = document.getElementById('product-grid');

  customViewBtns.forEach((viewBtn) => {
    viewBtn.addEventListener('click', function () {

      // remove active from all buttons
      customViewBtns.forEach((btn) => {
        btn.classList.remove('active');
      });

      // add active to clicked button
      this.classList.add('active');

      // get data-view value
      const viewType = this.dataset.view;

      if (viewType == 'list') {
        productContainer.classList.remove('grid');
        productContainer.classList.add('list_view');
        productContainer.classList.add('flex');
      } else if (viewType) {
        productContainer.classList.add('grid');
        productContainer.classList.remove('list_view');
        productContainer.classList.remove('flex');

      }
      console.log('Selected View:', viewType);

    });
  });

});